import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import "./CustomBackButton.scss";

interface CustomBackButtonProps {
  onClick: () => void;
  
}

const CustomBackButton: React.FC<CustomBackButtonProps> = ({ onClick }) => {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      className="back-button"
    >
      <FontAwesomeIcon icon={faArrowLeft} style={{ height: "18px", verticalAlign: "-0.16rem" }} />
      <span className="back-text" style={{ marginLeft: "0.5rem" }}>
        Regresar
      </span>
    </Button>
  );
};

export default CustomBackButton;
